let app

import LogDetails from '@/components/app/LogDetails'
const { getList } = require('@/api/base_entity')

export default {
  setApp: (appp) => {
    app = appp
  },
  'entityName': 'log',
  pagination: {
    'itemsPerPage': 5,
    'page': 1,
    'sortBy': 'insert_at',
    'descending': true
  },
  filterStorage: {},
  'fields': [
    {
      value: 'insert_at',
      text: 'Insert at',
      'type': 'date',
      'table': {
        'sortable': true,
        'filter': true
      },
      tooltip: () => {
        return "Click to copy the REQUEST and RESPONSE json into the clipboard"
      },
      click: (item) => {
        const value = {
          REQUEST: item.request,
          RESPONSE: item.response
        }
        navigator.clipboard.writeText(JSON.stringify(value, null, 2))
        app.clicked(item)
      }
    },
    {
      value: 'account.last_name',
      text: 'Account',
      'type': 'autocomplete',
      'table': {
        'sortable': false,
        'filter': true
      },
      filter: (item, search) => [{ 'account.first_name': `%${search}%`}, {'account.last_name' : `%${search}%`}],
      render: item => { return (item.account.first_name ? item.account.first_name : '') + ' ' + (item.account.last_name ? item.account.last_name : '') + ` (${item.account.role})` }
    },
    // {
    //   value: 'route',
    //   text: 'Route',
    //   'type': 'text',
    //   'table': {
    //     'sortable': false,
    //     'filter': true
    //   },
    // },
    // {
    //   value: 'http_verb',
    //   text: 'HTTP Method',
    //   type: 'list',
    //   list: ['POST', 'PUT', 'DELETE'],
    //   'table': {
    //     'sortable': false,
    //     'filter': true
    //   },
    //   filter: (item, search) => { return { 'http_verb': `${search}` } },
    // },

    {
      value: '_protocol',
      type: 'search_autocomplete',
      text: 'Protocol',
      reference: 'protocol',
      title: 'name',
      id: 'id',
      list: (entity, search) => getList('protocol', { name: `%${search}%`}),
      render: item => (item?.response?.data?.protocol ?? item?.request?.protocol ?? item?.protocol)?.name,
      filter: search => [{ response: `JSON(${search._protocol},$.data.protocol_id)` }, { request: `JSON(${search._protocol},$.protocol_id)` }],
      table: {
        sortable: false,
        filter: true
      },
      width: 100
    },
    {
      value: 'action',
      text: 'Action',
      table: {
        sortable: false,
        filter: true,
      },  
    },
    {
      value: 'section',
      text: 'Section',
      width: 100,
      table: {
        sortable: false,
        filter: true,
      },      
    },
    {
      value: 'record',
      text: 'Details',
      table: {
        sortable: false,
        filter: false,
        component: LogDetails
      },
    },

  ],
  actions: [
    { "value": "audit_trail", disable: item => !item.entity_id },

  ]
}
